import { Component, OnInit } from '@angular/core';

import { Campus } from 'src/app/core/models/api/campus.model';
import { CampusService } from 'src/app/core/services/api/campus.service';

@Component({
    selector: 'app-legal-advice',
    templateUrl: './legal-advice.component.html',
    styleUrls: ['./legal-advice.component.scss']
})
export class LegalAdviceComponent implements OnInit {

    public campus: Campus;
    public webResourceId: string = "legal-advice-page";

    constructor(private campusService: CampusService) { }

    ngOnInit() {

        this.campus = this.campusService.campusActive;

    }

}
